import CloseTimesScreen from "@/screens/CloseTimesScreen";

export default CloseTimesScreen;
